// extracted by mini-css-extract-plugin
export var active = "SubNavigation-module--active--nfEoc";
export var link = "SubNavigation-module--link--iIOL+";
export var pages = "SubNavigation-module--pages--GHvTi";
export var wrapper = "SubNavigation-module--wrapper--adULB";